<template>
    <div v-show="show" :class="wrapperCssClass">
        <slot>
            <label :for="id" v-if="showValidation || label">
                <span v-if="label" v-text="label"></span>
                <span class="validation" v-show="errors.has(name)" v-if="showValidation">
                    <span
                        v-for="(message, index) in validation"
                        v-show="errors.display(name, index)"
                        v-text="message"
                    ></span>
                </span>
            </label>
        </slot>
        <div class="input-group">
            <input
                type="text"
                :name="name"
                :id="id"
                :maxlength="maxlength"
                :placeholder="placeholder"
                :autocomplete="autocomplete"
                class="input-group-field"
                :class="invalidClass"
                :style="cssStyle"
                :value="value"
                @input="update($event.target.value)"
                v-focus="focus"
            >
            <form-button
                :submitting="submitting"
                :icon="buttonIcon"
                css-class="small expanded mrb0"
                group-class="input-group-button"
                :fire-event="fireEvent"
            ></form-button>
        </div>
    </div>
</template>
<script>
    import TextInput from '../../../mixins/Form/TextInput.vue';
    export default {
        mixins: [TextInput],
        props: {
            submitting: {
                type: Boolean,
                required: true
            },
            buttonLabel: {
                type: String,
                required: false
            },
            buttonIcon: {
                type: String,
                required: false
            }
        },
        computed: {
            buttonHtml() {
                let button = [];
                if (this.buttonIcon) {
                    button.push('<i class="' + this.buttonIcon + '"></i>');
                }
                if (this.buttonLabel) {
                    button.push(this.buttonLabel);
                }
                return button.join(' ');
            }
        }
    }
</script>